// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3jrPL","title":"Images90_title__3dlwG","images":"Images90_images__1qmzs"};